<template>
  <div class="flex w-full items-center space-x-2">
    <div class="w-18 h-18 relative">
      <o-dropdown
        :trigger="['contextmenu']"
        placement="bottom-start"
        :arrow="false"
        :disabled="!model.hasImage"
        :auto-hide="false"
      >
        <o-avatar :items="[model]" size="xl" />

        <template #content>
          <o-dropdown-item
            v-if="model.hasImage"
            :name="$t('asset.downloadImage')"
            icon="download"
            @click="handleOpenImage"
          />
        </template>
      </o-dropdown>
    </div>

    <o-button size="sm" flat outline @click="handleClick">
      {{ $t('components.fields.avatar.update') }}
    </o-button>
  </div>
</template>

<script setup lang="ts">
import OAvatar from '@/components/elements/Avatar.vue'
import ODropdownItem from '@/components/elements/dropdown/DropdownItem.vue'

interface Props {
  model: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'click'): void
}>()

function handleClick () {
  emit('click')
}

function handleOpenImage () {
  const image = props.model?.images?.large
  const target = '_blank'

  if (image) {
    window.open(image, target)
  }
}
</script>
